import { Status } from '@essent/common';
import { getCustomerClear } from '@essent/customer';
import type { FlowId } from '@essent/extension-offer';
import {
  putCurrentContract,
  putCurrentContractClear,
  putCurrentContractError,
  putCurrentContractSuccess,
} from '@essent/extension-offer';
import type { CollectionState } from '@innogy/utils-state';
import {
  createInitialCollectionState,
  updateCollectionState,
} from '@innogy/utils-state';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

export type FlowIdState = CollectionState<FlowId>;

export const unknownValue = 'unknown';

const initialState: FlowIdState = createInitialCollectionState();

const _flowIdReducer = createReducer(
  initialState,
  on(putCurrentContract, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.PENDING,
    })
  ),
  on(putCurrentContractSuccess, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.SUCCESS,
      entry: action.payload.metaData,
    })
  ),
  on(putCurrentContractError, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.ERROR,
      error: action.payload,
    })
  ),
  on(putCurrentContractClear, getCustomerClear, (_) => initialState)
);

export function flowIdReducer(
  state: FlowIdState = initialState,
  action: Action
): FlowIdState {
  return _flowIdReducer(state, action);
}
